export const Splatter = ({ className = "" }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
    <div className="blob" style={{ background: "#E6007E", width: 420, height: 420, top: -80, left: -60 }} />
    <div className="blob" style={{ background: "#0055FF", width: 360, height: 360, top: 120, right: -80 }} />
    <div className="blob" style={{ background: "#E6007E", width: 300, height: 300, bottom: -100, left: "35%" }} />
  </div>
);

export default Splatter;
